import React from 'react'

export default () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM3.33333 14.1667V5.83333H5.19802V9.01961H7.37349V5.83333H9.23817V14.1667H7.37349V10.4669H5.19802V14.1667H3.33333ZM10.5287 5.83333H12.6783L14.9315 11.5406H14.9574V5.83333H16.6667V14.1667H14.543L12.2639 8.331H12.238V14.1667H10.5287V5.83333Z"
      fill="#A0AEC0"
    />
  </svg>
)
